// src/services/UserQuery.api.ts
//
// POSTs the "Discuss Your Campaign" contact form to the backend so it's
// saved as a user query/lead. The exact endpoint path below
// (`/user-query`) is a placeholder — swap it for whatever your backend
// team confirms (e.g. `/brand/user-query`, `/leads`, `/contact`), it
// follows the same relative-path pattern as Brandlistings.api.ts.

import axios from "axios";
import httpClient from "./httpClient";
import { UserQueryPayload, SubmitUserQueryResponse } from "../types/userquerymodel";

export const submitUserQuery = async (payload: UserQueryPayload): Promise<{ id: string } | null> => {
  try {
    const { data } = await httpClient.post<SubmitUserQueryResponse>("/user-query", payload);
    if (!data.success) {
      throw new Error(data.message || "Failed to submit your message.");
    }
    return data.result;
  } catch (err) {
    if (axios.isAxiosError<SubmitUserQueryResponse>(err)) {
      throw new Error(err.response?.data?.message || "Failed to submit your message.");
    }
    throw err;
  }
};